module.exports = __webpack_public_path__ + "img/pizza-icon.d932b7b5.svg";